import { render, staticRenderFns } from "./MonetaryGiftManager.vue?vue&type=template&id=16a90289&scoped=true&"
import script from "./MonetaryGiftManager.vue?vue&type=script&lang=js&"
export * from "./MonetaryGiftManager.vue?vue&type=script&lang=js&"
import style0 from "./MonetaryGiftManager.vue?vue&type=style&index=0&id=16a90289&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a90289",
  null
  
)

export default component.exports